import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handleDateChangeEvent, handlePost } from '../../../../../utils/AxiosUtil';
import * as util from '../../../../../utils/Util';
import ErrorAwareAmountField from '../../../../common/inputfields/ErrorAwareAmountField';
import ErrorAwareDatePicker from '../../../../common/inputfields/ErrorAwareDatePicker';
import ErrorAwareTextField from '../../../../common/inputfields/ErrorAwareTextField';
import ErrorAwareYearPicker from '../../../../common/inputfields/ErrorAwareYearPicker.js';
import NewAgainField from '../../../../common/inputfields/NewAgainField';

class NewAvailableDividend extends Component {
    state = {
        newAgain: false,
        year: new Date(),
        amount: '',
        availableFrom: new Date(),
        availableUntil: new Date(),
        comment: '',
        errors: new Map(),
    }

    resetForm = () => {
        this.setState({
            newAgain: false,
            year: new Date(),
            amount: '',
            availableFrom: new Date(),
            availableUntil: new Date(),
            comment: '',
            errors: new Map(),
        })
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/availabledividend';
        const requestObject = {
            "year": this.state.year.getFullYear(),
            "amount": util.toNumber(this.state.amount),
            "availableFrom": this.state.availableFrom,
            "availableUntil": this.state.availableUntil,
            "comment": this.state.comment,
        };

        handlePost(path, requestObject, this);
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <ErrorAwareYearPicker
                            required
                            name="year"
                            label="Év"
                            errors={this.state.errors}
                            value={this.state.year}
                            onChange={e => handleDateChangeEvent(e, "year", this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            id="amount"
                            name="amount"
                            label="Összeg"
                            errors={this.state.errors}
                            value={this.state.amount}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            name="availableFrom"
                            label="Mikortól"
                            errors={this.state.errors}
                            value={this.state.availableFrom}
                            onChange={e => handleDateChangeEvent(e, "availableFrom", this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            name="availableUntil"
                            label="Meddig"
                            errors={this.state.errors}
                            value={this.state.availableUntil}
                            onChange={e => handleDateChangeEvent(e, "availableUntil", this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Megjegyzés"
                            errors={this.state.errors}
                            value={this.state.comment}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                </div>
                <div className="form-actions">
                    <NewAgainField
                        checked={this.state.newAgain}
                        onChange={e => this.setState({ newAgain: e.target.checked })} />
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                    Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewAvailableDividend);
